export default __webpack_public_path__ + "static/media/scorpio.cdb12218.png";